export default __webpack_public_path__ + "static/media/brambouwtlogo.2702f8d7.png";